import React from 'react';
import { USP_PROVIDERS } from '../data/uspProviders';

/**
 * ProviderBadges — dezente Mini-Logos der Dienstleister je USP.
 * Nur Logos, grayscale und nebensächlich; Tooltip via title.
 */
export default function ProviderBadges({
  slug,
  dark = false,
  max = 3,
  compact = false,
  testId,
  className = '',
}) {
  const providers = (USP_PROVIDERS[slug] || []).filter((p) => p.logo).slice(0, max);
  if (providers.length === 0) return null;

  // Compact-Variante (Konfigurator, Checkout, Warenkorb) — kleinere Logos, damit sie in engen Sidebar-Layouts nicht überlappen
  const gapCls = compact ? 'gap-1.5' : 'gap-2.5';
  const darkChipCls = compact ? 'h-5 px-1.5' : 'h-8 px-2.5';
  const darkImgCls = compact ? 'h-3 max-w-[52px]' : 'h-5 max-w-[80px]';
  const lightImgCls = compact
    ? 'h-4 sm:h-4 max-w-[60px]'
    : 'h-5 sm:h-7 max-w-[80px] sm:max-w-[92px]';

  return (
    <div
      className={`flex flex-wrap items-center ${gapCls} ${className}`}
      data-testid={testId || `provider-badges-${slug}`}
    >
      {providers.map((p) =>
        dark ? (
          <span
            key={p.name}
            title={p.benefit ? `${p.name} — ${p.benefit}` : p.name}
            className={`inline-flex items-center justify-center rounded-md bg-white/95 ${darkChipCls}`}
          >
            <img src={p.logo} alt={p.name} loading="lazy" className={`w-auto object-contain ${darkImgCls}`} />
          </span>
        ) : (
          <img
            key={p.name}
            src={p.logo}
            alt={p.name}
            title={p.benefit ? `${p.name} — ${p.benefit}` : p.name}
            loading="lazy"
            className={`w-auto object-contain opacity-70 saturate-[0.85] hover:opacity-100 hover:saturate-100 transition-[filter,opacity] duration-300 ${lightImgCls}`}
          />
        )
      )}
    </div>
  );
}
